import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const NotesBlockWrapper = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  gap: "10px",
});

export const NotesBlockContainer = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "15px",
  padding: "10px 0px",
  height: "100%",
});

export const NotesTextfieldContainer = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  alignItems: "center",
});

export const ChatContainer = styled(Grid)({
  width: "100%",
  minHeight: "fit-content",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  // overflow: "auto",
});

export const NotesMessagesContainer = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "5px",
  // height: "calc(100% - 65px)",
});

export const MessageContainer = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
});

export const RequestContainer = styled(Grid)({
  display: "flex",
  gap: "10px",
  width: "100%",
  alignItems: "center",
});
